import { AddressWebEntity } from "./address-web-entity";
import { Mapper } from "../../../../../core/base";
import { Address } from "../../../../../core/domain/models/address";

export class AddressWebRepositoryMapper extends Mapper<AddressWebEntity, Address> {
  mapFrom(param: AddressWebEntity): Address {
    return {
      street: param.street,
      city: param.city,
      state: param.state,
      country: param.country,
      receivedAddress: param.receivedAddress,
      houseNumber: param.houseNumber,
      postalCode: param.postalCode
    };
  }

  mapTo(param: Address): AddressWebEntity {
    return {
      street: param.street,
      city: param.city,
      state: param.state,
      country: param.country,
      receivedAddress: param.receivedAddress,
      houseNumber: param.houseNumber,
      postalCode: param.postalCode
    };
  }
}
